import apiClient from "./axiosConfig";

export const getDealershipEnums = async () =>
    apiClient.feesAPI.get(`/api/v1/dealership-admin/enums`);

export const getDealerships = async (country) =>
    apiClient.feesAPI.get(`/api/v1/dealership-admin/?country=${country}`);

export const createDealership = async (request) =>
    apiClient.feesAPI.post(`/api/v1/dealership-admin/create`, request);

export const updateDealerships = async (request) =>
    apiClient.feesAPI.put(
        `/api/v1/dealership-admin/updateDealerships`,
        request,
    );

export const deleteDealerships = async (request) =>
    apiClient.feesAPI.delete(`/api/v1/dealership-admin/`, { data: request });
